import * as pxp from '../lib/pxp'

// https://www.msmaster.qa.paypal.com/elmo/experiment/105570
// https://admin.paypalinc.com/elmo/experiment/102056
export const hasFIPayRequestPostMigration = () =>
  pxp.isTreatment('Trmt_p2p_fi_pay_request_post_migrate')

export const hasAddFiPostMigration = () =>
  pxp.isTreatment('Trmt_p2p_add_fi_post_migrate')
